// 名片头像上传后更改头像
export const CARD_HEAD_CHANGE_AVATAR = 'passover_h5_frontend/CARD_HEAD_CHANGE_AVATAR';

// 获取名片头部基本信息
export const CARD_GET_BASIC_DETAILS = 'passover_h5_frontend/CARD_GET_BASIC_DETAILS';
